module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Diff Ltd","short_name":"Diff","start_url":"/","background_color":"#E6E6FA","theme_color":"#E6E6FA","display":"minimal-ui","icon":"src/images/diff-compact-transp.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"6714c041ecb86ba00f2a0af3c221d4e0"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
